import { Table, TableWrapper } from '@4beefopag/4bee-fopag-core/dist/atoms';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { operacaoLogProps } from '../../atoms/Props';
import { HeaderWithSort } from '../../atoms/Table';
import PayrollDetailSection from '../../molecules/PayrollDetailSection';
import PayrollLogRow from '../../molecules/PayrollLogRow';

const TableWrapperCustom = styled(TableWrapper)`
  padding: 0;
`;

const TablePadding = styled.div`
  padding: 8px;
  margin-top: 18px;
  margin-bottom: 18px;
  background-color: white;
`;

const TableCustom = styled(Table)`
  width: 100%;

  tr {
    text-align: left;
  }
`;

function PayrollLogTable({ logs = [], onChangeOrder, orderBy }) {
  const clickOrderBy = (key, value) => {
    onChangeOrder({ [key]: value });
  };

  return (
    <PayrollDetailSection title="Histórico de Atualizações">
      <TablePadding>
        <TableWrapperCustom>
          <TableCustom
            background="#f6f7f9"
            borderBottomTh="1px solid #e8e8e8"
            borderBottomTd="1px solid #e8e8e8"
          >
            <thead>
              <tr>
                <HeaderWithSort
                  orderType={orderBy.insercao}
                  clickOnOrder={(orderType) => clickOrderBy('insercao', orderType)}
                  label="Data/Hora da Operação"
                />
                <HeaderWithSort
                  orderType={orderBy.tipoOperacao}
                  clickOnOrder={(orderType) => clickOrderBy('tipoOperacao', orderType)}
                  label="Operação"
                />
                <HeaderWithSort
                  orderType={orderBy.usuario}
                  clickOnOrder={(orderType) => clickOrderBy('usuario', orderType)}
                  label="Responsável"
                />
                <HeaderWithSort
                  orderType={orderBy.dataPrevistaFatura}
                  clickOnOrder={(orderType) => clickOrderBy('dataPrevistaFatura', orderType)}
                  label="Vencimento Previsto da Fatura"
                />
                <HeaderWithSort
                  orderType={orderBy.faturadoEm}
                  clickOnOrder={(orderType) => clickOrderBy('faturadoEm', orderType)}
                  label="Vencimento da Fatura"
                />
                <HeaderWithSort
                  orderType={orderBy.dataPrevistaPagamento}
                  clickOnOrder={(orderType) => clickOrderBy('dataPrevistaPagamento', orderType)}
                  label="Pagamento Cooperado"
                />
                <HeaderWithSort
                  orderType={orderBy.dataProcessamento}
                  clickOnOrder={(orderType) => clickOrderBy('dataProcessamento', orderType)}
                  label="Data Processamento"
                />
                <HeaderWithSort
                  orderType={orderBy.valorPortal}
                  clickOnOrder={(orderType) => clickOrderBy('valorPortal', orderType)}
                  label="Valor do Portal"
                />
                <HeaderWithSort
                  orderType={orderBy.valorLiquidoFolha}
                  clickOnOrder={(orderType) => clickOrderBy('valorLiquidoFolha', orderType)}
                  label="Valor Líquido Folha"
                />
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <PayrollLogRow
                  key={`log-row-${log.id}`}
                  log={log}
                />
              ))}
            </tbody>
          </TableCustom>
        </TableWrapperCustom>
      </TablePadding>
    </PayrollDetailSection>
  );
}
PayrollLogTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      colaborador: operacaoLogProps,
    })
  ),
  onChangeOrder: PropTypes.func.isRequired,
  orderBy: PropTypes.shape().isRequired,
};

PayrollLogTable.defaultProps = {
  logs: [],
};

export default PayrollLogTable;
